import { useState } from "react";
import { useTranslation } from "react-i18next";
import SponsoredPost from "./SponsoredPost";
import NormalPost from "./NormalPost";
import CompanyPost from "./CompanyPost";
import AdCard from "./AdCard";
import EmptyState from "./EmptyState";

const tabs = ["For You", "Following", "Ads"];

export const fakeAds = [
  {
    id: 1,
    type: "ads",
    banner: "https://images.unsplash.com/photo-1492724441997-5dc865305da7",
    logo: "https://i.pravatar.cc/40?img=1",
    companyName: "NeoWare Company",
  },
  {
    id: 2,
    type: "ads",
    banner: "https://images.unsplash.com/photo-1559027615-cd4628902d4a",
    logo: "https://i.pravatar.cc/40?img=2",
    companyName: "InnoTech Labs",
  },
  {
    id: 3,
    type: "ads",
    banner: "https://images.unsplash.com/photo-1581091012184-5c1d1bcd6d66",
    logo: "https://i.pravatar.cc/40?img=3",
    companyName: "HealthPlus Medical",
  },
  {
    id: 4,
    type: "ads",
    banner: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d",
    logo: "https://i.pravatar.cc/40?img=4",
    companyName: "Creative Studio Pro",
  },
  {
    id: 5,
    type: "ads",
    banner: "https://images.unsplash.com/photo-1531297484001-80022131f5a1",
    logo: "https://i.pravatar.cc/40?img=5",
    companyName: "WebCraft Agency",
  },
  {
    id: 6,
    type: "ads",
    banner: "https://images.unsplash.com/photo-1556761175-4b46a572b786",
    logo: "https://i.pravatar.cc/40?img=6",
    companyName: "Skyline Marketing",
  },
];

const Posts = ({ locale = "en", posts }) => {
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const { t } = useTranslation();
  // console.log(posts)
  return (
    <div className="max-w-2xl mx-auto space-y-4">
      {/* Header with title + tabs */}
      <div
        className={`flex ${locale === "ar" ? "flex-row-reverse" : ""} items-center justify-between `}
      >
        <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100">
          {t("LatestNews")}
        </h2>

        <div className="flex gap-1 lg:gap-3">
          {tabs?.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-3 py-1 rounded-full text-sm font-medium transition-colors duration-200
                            ${activeTab === tab
                  ? "dark:bg-primary bg-primary-light dark:text-bg-dark-primary text-bg-light-primary"
                  : " text-text-muted-light dark:bg-bg-dark-tertiary bg-bg-light-tertiary dark:text-text-muted-dark"
                }`}
            >
              {t(tab)}
            </button>
          ))}
        </div>
      </div>

      {/* TAB CONTENT */}
      <div className="">
        {activeTab === "For You" && (
          posts?.length === 0 ? (
            <EmptyState
              titleKey="feed.noPosts"
              descKey="feed.noPostsDesc"
            />
          ) : (
            <div className="grid grid-cols-1 gap-6">
              {posts.map((post) =>
                post?.isSponsored ? (
                  <SponsoredPost key={post?.id} post={post} />
                ) : post.isCompany ? (
                  <CompanyPost key={post?.id} post={post} />
                ) : (
                  <NormalPost key={post?.id} post={post} />
                )
              )}
            </div>
          )
        )}

        {activeTab === "Following" && (
          posts?.length === 0 ? (
            <EmptyState
              titleKey="feed.noFollowingPosts"
              descKey="feed.noFollowingDesc"
            />
          ) : (
            <div className="grid grid-cols-1 gap-6">
              {posts.map((post) =>
                post.type === "ads" ? (
                  <SponsoredPost key={post?.id} post={post} />
                ) : post.isCompany ? (
                  <CompanyPost key={post?.id} post={post} />
                ) : (
                  <NormalPost key={post?.id} post={post} />
                )
              )}
            </div>
          )
        )}

        {activeTab === "Ads" && (
          fakeAds?.filter((post) => post.type === "ads")?.length === 0 ? (
            <EmptyState
              titleKey="feed.noAds"
              descKey="feed.noAdsDesc"
            />
          ) : (
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              {fakeAds
                ?.filter((post) => post.type === "ads")
                ?.map((ad) => (
                  <AdCard key={ad.id} ad={ad} />
                ))}
            </div>
          )
        )}

      </div>

    </div>
  );
};

export default Posts;
